import * as apiValues from '../constants/apiValues';
import { EMAIL_FIELD_HINT, EMAIL_REGISTER_OPTIONS } from '../constants/formValidation';
import { DEFAULT_NEWSLETTER_TAG, resolveNewsletterTags } from '../helpers/mailchimpTags';
import * as mNewsletterActions from '../actions/mNewsletterActions';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import SuperLink from './SuperLink';
import ValidatedFormField from './ValidatedFormField';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '../withRouterCompat';

function MNewsLetter(props) {
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = values => {
    setFormError('');
    setFormSuccess(false);
    const tags = Array.isArray(props.tags) && props.tags.length
      ? props.tags
      : resolveNewsletterTags({
          mailchimpTag: props.mailchimpTag,
          slug: props.slug,
          kind: props.tagKind,
          source: props.source,
        });
    const body = { email: values.email, tags: tags.length ? tags : [DEFAULT_NEWSLETTER_TAG] };
    if (props.listId) body.listId = props.listId;

    fetch(`${apiValues.getCmsPath()}/api/newsoptin`, {
      method: 'post',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(
      result => {
        if (result.ok) setFormSuccess(true);
        else handleFailure(result);
      },
      result => handleFailure(result),
    );
  };

  function handleFailure(result) {
    console.error('handleValidSubmitFailure', result);
    setFormError('There was a problem signing you up. Please try again later.');
    setFormSuccess(false);
  }

  function renderForm() {
    if (formSuccess) return null;

    return (
      <div className="m-newsletter__form">
        {props.hideDescription ? null : (
          <div className="m-newsletter__description">
            Sign up here to be informed by email about our latest news and events.
          </div>
        )}
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <ValidatedFormField
            id="m-newsletter-email"
            name="email"
            label="Email Address"
            type="email"
            required
            hint={props.hideHint ? undefined : EMAIL_FIELD_HINT}
            error={errors.email}
            register={register}
            registerOptions={EMAIL_REGISTER_OPTIONS}
          />
          {formError ? (
            <p className="form-error" role="alert">
              {formError}
            </p>
          ) : null}
          <button type="submit" className="tg-button tg-button--pill tg-button--black m-newsletter__submit">
            <span className="tg-button__label">Sign Up</span>
          </button>
        </form>
      </div>
    );
  }

  function renderSuccess() {
    if (!formSuccess) return null;

    return (
      <div className="m-newsletter__form" role="status">
        <div className="m-newsletter__big">Thank you for Signing Up!</div>
        <p>
          Learn more about our projects <SuperLink to={'/projects'}>here</SuperLink>.
        </p>
      </div>
    );
  }

  const title = props.title || 'SIGN UP FOR UPDATES';
  const compactClass = props.compact ? 'm-newsletter--compact' : '';
  const TitleTag = props.compact ? 'h2' : 'div';
  const inner = (
    <React.Fragment>
      <TitleTag className="m-newsletter__title">{title}</TitleTag>
      <div className="m-newsletter__content">
        {renderForm()}
        {renderSuccess()}
      </div>
    </React.Fragment>
  );

  return (
    <div className={`m-newsletter ${compactClass} ${props.className || ''}`}>
      {props.compact ? inner : (
        <div className="container container--coupling">
          {inner}
        </div>
      )}
    </div>
  );
}

export default withRouter(
  connect(
    state => ({
      mNewsletter: state.mNewsletter,
    }),
    dispatch => ({
      actions: bindActionCreators(mNewsletterActions, dispatch),
    }),
  )(MNewsLetter),
);

MNewsLetter.propTypes = {
  actions: PropTypes.object,
  className: PropTypes.string,
  compact: PropTypes.bool,
  hideDescription: PropTypes.bool,
  hideHint: PropTypes.bool,
  listId: PropTypes.string,
  mailchimpTag: PropTypes.string,
  mNewsletter: PropTypes.object,
  slug: PropTypes.string,
  source: PropTypes.string,
  tagKind: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
};
